import { Component, input, output } from "@angular/core";
import { MatButton, MatIconButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

/** Today / previous / next over a chart, with the span in view. The chart shows it only when it can page. */
@Component({
  selector: "lib-timeline-nav",
  imports: [MatButton, MatIconButton, MatIcon],
  template: `
    <button
      matButton="outlined"
      type="button"
      (click)="today.emit()"
    >
      Today
    </button>
    <button
      mat-icon-button
      type="button"
      [attr.aria-label]="'Previous ' + unit()"
      [disabled]="atFirst()"
      (click)="step.emit(-1)"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      [attr.aria-label]="'Next ' + unit()"
      [disabled]="atLast()"
      (click)="step.emit(1)"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
    <h2 class="title">{{ title() }}</h2>
  `,
  styles: `
    :host {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 6px 12px;
      border-bottom: 1px solid #e0e0e0;
    }

    .title {
      margin: 0 0 0 8px;
      font-size: 15px;
      font-weight: 500;
      white-space: nowrap;
    }
  `,
})
export class TimelineNav {
  /** The span in view, e.g. "Oct 19 – Nov 15, 2026" or "November 2026". */
  readonly title = input.required<string>();
  /** What one step moves, for the button names: "week" or "month". */
  readonly unit = input.required<string>();
  readonly atFirst = input(false);
  readonly atLast = input(false);
  readonly today = output<void>();
  readonly step = output<1 | -1>();
}
